import { createSelector } from 'reselect'
import equipmentRequestIsPendingSelector from '../pending-request/equipmentRequestIsPendingSelector'
import configurationRequestIsPendingSelector from '../pending-request/configurationRequestIsPendingSelector'

const equipmentSelectionIsLoadingSelector = createSelector(
    equipmentRequestIsPendingSelector,
    configurationRequestIsPendingSelector,
    (equipmentRequestIsPending, configurationRequestIsPending): boolean => (
        equipmentRequestIsPending || configurationRequestIsPending
    ),
)

export default equipmentSelectionIsLoadingSelector
